import {
  Box,
  Icon,
  SidebarMenuButton,
  SidebarMenuItem,
  Text,
  type IconName,
} from "@salestrak/ui";
import React from "react";

import { useCloseSidebarIfMobile } from "#app/lib/mobile-sidebar-context";
import { useExternalAppLinks } from "#app/lib/hooks/use-external-app-links";
import { SidebarSection } from "@salestrak/ui";

/**
 * "Apps" module-menu section — external companion apps, driven by the
 * workspace's `externalAppLinks` setting. Renders nothing when the workspace
 * has no links configured (HomeModuleMenu also skips the section in that case,
 * so this is a defensive guard).
 */
export function AppsSection() {
  const closeSidebar = useCloseSidebarIfMobile();
  const links = useExternalAppLinks();

  if (links.length === 0) return null;

  return (
    <SidebarSection title="Apps">
      {links.map((link, index) => (
        <SidebarMenuItem key={`${link.url}-${index}`}>
          {/* A real anchor — external links open through the element, not
            * through an imperative navigator. */}
          <SidebarMenuButton
            onClick={closeSidebar}
            render={
              <Box
                as="a"
                href={link.url}
                rel="noopener noreferrer"
                target="_blank"
              />
            }
          >
            <Icon name={link.icon as IconName} />
            <Text truncate>{link.label}</Text>
            <Icon
              className="ms-auto"
              color="muted"
              name="external-link"
              size="sm"
            />
          </SidebarMenuButton>
        </SidebarMenuItem>
      ))}
    </SidebarSection>
  );
}
